"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceDuePeriodEnum = void 0;
var InvoiceDuePeriodEnum;
(function (InvoiceDuePeriodEnum) {
    InvoiceDuePeriodEnum["Day"] = "Day";
    InvoiceDuePeriodEnum["Month"] = "Month";
})(InvoiceDuePeriodEnum = exports.InvoiceDuePeriodEnum || (exports.InvoiceDuePeriodEnum = {}));
